import { useEffect, useState } from 'react';
import { IStudy } from '@vivli/features/studies/infrastructure/interface';
import { first } from 'rxjs/operators';
import { useActiveUserContext, useDataPackageApiContext, useStudiesApiContext } from '@vivli/core/infrastructure/context';
import { useModalApiContext } from '@vivli/core/infrastructure/context';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';

export function useStudyWithUserCheck(studyId: string, fromDoi?: boolean, needUsedIn?: boolean) {
    const [study, setStudy] = useState<IStudy>();
    const [studyUsedIn, setStudyUsedIn] = useState<string>(null); //string listing data requests studies used in
    const [studyIpdDataPackageSubmitted, setStudyIpdDataPackageSubmitted] = useState<boolean>(false); //is IPD data package submitted

    const studiesService = useStudiesApiContext();
    const dataPackageService = useDataPackageApiContext();
    const { user, orgHasPermission, hasPermission } = useActiveUserContext();
    const modalService = useModalApiContext();

    const handleError = (error: string) => {
        modalService.error(error);
    };

    useEffect(() => {
        if (!studyId) {
            return;
        }

        if (!fromDoi) {
            //normal case where ID used is study ID
            if (user) {
                studiesService.getStudy(studyId).pipe(first()).subscribe(setStudy);
                //check to see if "usedIn" string is required along with study access
                const thisStudy = study;
                //TODO PERMFE - redo with permissions+
                const isOwner = orgHasPermission(thisStudy?.orgId, PermissionsEnum.ProviderActAdv);
                //TODO PERMFE - redo with permissions+
                if (hasPermission(PermissionsEnum.EditStudyAdv) || isOwner || needUsedIn) {
                    studiesService.getUsedIn(studyId).pipe(first()).subscribe(setStudyUsedIn);
                }
            } else {
                //anonymous access allowed without logged in user
                studiesService.getStudyAnonymous(studyId).pipe(first()).subscribe(setStudy);
            }
        } else {
            //ID in this case comes from the DOI, not the study id
            studiesService.getStudyFromDoiId(studyId).pipe(first()).subscribe(setStudy, handleError);
        }
    }, [studyId]);

    useEffect(() => {
        if (study === null || study === undefined) {
            return;
        }
        if (study.ipdDataPackageId) {
            dataPackageService.getDataPackageSubmitStatus(study.ipdDataPackageId).pipe(first()).subscribe(setStudyIpdDataPackageSubmitted);
        } else {
            // for 8187, if studyIPD DataPackage does not exist, and an OrgId is in place, then create the missing IPD package document
            if (study.orgId) {
                studiesService.createIpdDataPackage(studyId).pipe(first()).subscribe(setStudy);
            }
        }
    }, [study]);

    return {
        study,
        setStudy,
        studyUsedIn,
        studyIpdDataPackageSubmitted,
        setStudyIpdDataPackageSubmitted,
    };
}
